export function googleMapsEnable(elementClassName) {
    var element = document.getElementById(elementClassName);
    var googleKey = element.dataset.key;
    var mapId = element.dataset.mapId;

    // Create the script tag, set the appropriate attributes
    var script = document.createElement('script');
    script.src =
        'https://maps.googleapis.com/maps/api/js?key=' +
        googleKey +
        '&callback=initMap&v=weekly&libraries=marker';
    script.defer = true;
    script.async = true;

    // Attach your callback function to the `window` object
    window.initMap = async function () {
        var map;

        // JS API is loaded and available
        var places = document.getElementById('google-maps-block')
            ? JSON.parse(
                document
                    .getElementById('google-maps-block')
                    .getAttribute('data-coords')
            )
            : [];
        var bounds = new google.maps.LatLngBounds();

        const { Map } = await google.maps.importLibrary('maps');
        const { AdvancedMarkerElement } = await google.maps.importLibrary(
            'marker'
        );

        map = new Map(document.getElementById(elementClassName), {
            mapId: mapId,
        });

        for (var i = 0; i < places.length; i++) {
            bounds.extend(places[i]);

            const pinElement = document.createElement('div');
            pinElement.className = 'google-maps-custom-pin';

            var marker = new AdvancedMarkerElement({
                position: places[i],
                content: pinElement,
                map: map,
            });

            marker.placeUrl = places[i].url;
            marker.addListener('click', function () {
                window.location.href = this.placeUrl;
            });
        }

        google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
            this.setZoom(map.getZoom() + 0.5);
            if (this.getZoom() > 15) {
                this.setZoom(15);
            }
        });

        map.fitBounds(bounds);
    };

    // Append the 'script' element to 'head'
    document.head.appendChild(script);
}

document.addEventListener('DOMContentLoaded', () => {

    if (document.getElementById('map-block')) {
        const className = 'map-block';
        googleMapsEnable(className);
    }
});
